import {Link} from 'react-router-dom'
import './header.css'
//Base api  https://api.themoviedb.org/3
// https://api.themoviedb.org/3/movie/now_playing?api_key=28fc232cc001c31e8a031f419d0a14ca&language=pt-BR
function Header(){
    return(
        <header>
            <Link className='logo' to='/'>Prime Flix</Link>
            <Link className='favoritos' to='/favoritos'>Meus Filmes</Link>
        </header>
           
        
    )
}

export default Header;